<template>
  <div class="question-editor">
    <div class="question-pd">
      <!-- 头部 -->
      <div class="question-header">
        <div class="question-header-left">
          <div>
            <span v-if="isMust" class="asterisk">*</span>
            <span class="question-number">
              {{
                `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、`
              }}
            </span>
          </div>
          <div class="question-select">
            <span>图片/视频</span>
          </div>
        </div>
        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            lazy-load
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            lazy-load
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            lazy-load
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>

      <!-- 标题输入框 -->
      <div
        class="textarea-box"
        :style="{
          border:
            isFocusIndex === '-1'
              ? '1px solid rgba(58,96,255,0.5)'
              : '1px solid #DCDDE0',
        }"
      >
        <textarea
          class="case-problem-textarea"
          v-model.lazy="caseProblem"
          placeholder="请观看图片/视频"
          maxlength="500"
          :disabled="dataObj.disabled"
          @focus="isFocusIndex = '-1'"
          @blur="isFocusIndex = ''"
          @input="handleUpdate"
        ></textarea>
        <div class="textarea-footer">
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
            style="width: 18px; height: 18px; cursor: pointer"
            @click="handleCaseProblemImg"
          />
          <div @click="clearQuestion" class="clear-btn">清空</div>
        </div>
      </div>

      <!-- 题目封面图 -->
      <div class="question-images">
        <div
          v-for="(item, index) in images"
          :key="index"
          style="margin-top: 10px; position: relative"
        >
          <img :src="item" style="width: 100%" />
          <img
            src="@/assets/images/guanbi.png"
            class="guanbi"
            @click="handleDeleteQuestionImage(index)"
          />
        </div>
      </div>

      <!-- 图片/视频列表 -->
      <div class="image-options">
        <div v-for="(option, index) in list" :key="index">
          <!-- 图片 -->
          <div
            v-if="option.type === 'image'"
            class="image-view"
            @click="showBigImage(option.url)"
          >
            <img
              src="@/assets/images/guanbi.png"
              class="del"
              @click.stop="delItem(index)"
            />
            <img :src="option.url" class="img" />
          </div>

          <!-- 视频 -->
          <div v-else-if="option.type === 'video'" class="image-view">
            <img
              src="@/assets/images/guanbi.png"
              class="del"
              @click.stop="delItem(index)"
            />
            <video :src="option.url" style="width: 100%" controls></video>
          </div>

          <!-- 上传占位 -->
          <div
            v-else
            class="image-view"
            style="height: 240px"
            @click="handleItemImage(index)"
          >
            <img
              src="@/assets/images/guanbi.png"
              class="del"
              @click.stop="delItem(index)"
            />
            <div class="plus-icon"></div>
            <span>点击上传图片/视频</span>
          </div>
        </div>
      </div>

      <!-- 大图预览 -->
      <el-dialog
        title="预览"
        :visible.sync="fangdaShow"
        width="60%"
        @close="fangdaClose"
      >
        <img :src="fangdaImgUrl" style="width: 100%" />
      </el-dialog>

      <!-- 操作栏 -->
      <div class="add-view">
        <div class="required">
          <el-checkbox
            v-model="isMust"
            label="必选题"
            size="mini"
          ></el-checkbox>
        </div>
        <div @click="addOption" class="add-btn">
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737858857723.png"
            style="width: 12.5px; height: 12.5px"
          />
          <span>添加图片/视频 {{ list.length }}/5</span>
        </div>
        <div class="add-batch" style="color: #ffffff">批量添加</div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="question-footer">
      <div class="save-btn" @click="saveClick">保存</div>
    </div>

    <!-- 上传选择弹窗（替代 up-action-sheet） -->
    <el-dialog
      title="选择上传方式"
      :visible.sync="showAction"
      width="30%"
      @close="showAction = false"
    >
      <el-button type="primary" plain block @click="onAlbumImg"
        >本地上传</el-button
      >
    </el-dialog>

    <!-- 隐藏文件上传框 -->
    <input
      ref="uploadInput"
      type="file"
      accept="image/*,video/*"
      class="hidden-upload"
      @change="handleFileChange"
    />
  </div>
</template>

<script>
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";

export default {
  name: "QuestionMedia",
  props: {
    params: { type: Object, default: () => ({}) },
    index: { type: Number, default: 0 },
    updateType: { type: Number, default: 0 },
    type: { type: Number, default: 1 },
  },
  data() {
    return {
      list: [],
      dataObj: {},
      ifRandomize: false,
      isMust: false,
      showpopup: false,
      showUpload: false,
      uploadIndex: 0,
      images: [],
      caseProblem: "",
      isFocusIndex: "",
      inputFocusIndex: "",
      showAction: false,
      actions: [
        { name: "拍摄照片/视频" },
        { name: "从相册选取" },
        { name: "从聊天记录选取" },
      ],
      fangdaShow: false,
      fangdaImgUrl: "",
      fangdaTitle: "",
    };
  },
  watch: {
    params: {
      handler(newVal) {
        this.dataObj = { ...newVal };
        this.caseProblem = newVal.caseProblem;
        this.list = JSON.parse(newVal.chooseList || '{"list":[]}').list;
        this.isMust = newVal.isMust === 1;
        this.images = JSON.parse(newVal.caseProblemImg || "[]");
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        }),
      );
    },
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdate();
    },
    addOption() {
      if (this.list.length < 5) {
        this.list.push({ url: "", type: "" });
        this.handleUpdate();
      } else {
        this.$message.warning("最多5个");
      }
    },
    delItem(index) {
      this.list.splice(index, 1);
      this.handleUpdate();
    },
    handleCaseProblemImg() {
      this.uploadIndex = -1;
      this.$refs.uploadInput.click();
    },
    handleItemImage(index) {
      this.uploadIndex = index;
      // this.showAction = true;
      this.$refs.uploadInput.click();
    },
    onAlbumImg() {
      this.showAction = false;
      this.$refs.uploadInput.click();
    },
    async handleFileChange(event) {
      console.log(event.target.files[0]);

      const file = event.target.files[0];
      const fileType = file.type.split("/")[0];
      const formData = new FormData();

      if (fileType === "video") {
        const timestamp = Date.now();
        const randomStr = Math.random().toString(36).substr(2, 6);
        const fileExtension = file.name.split(".").pop() || "mp4";
        const fileName = `video_${timestamp}_${randomStr}.${fileExtension}`;
        const newFile = new File([file], fileName, { type: file.type });
        formData.append("uuid", localStorage.getItem("uuid") || "");
        formData.append("file", newFile);
      } else {
        formData.append("file", file); // "file" 对应后端接收的字段名
        formData.append("uuid", this.uuid);
      }

      this.$refs.uploadInput.value = "";
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.$message.success("上传成功！");
          if (this.uploadIndex === -1) {
            this.images = [response.data.urls];
          } else {
            this.list[this.uploadIndex].url = [response.data.urls];
            this.list[this.uploadIndex].type = fileType;
          }

          console.log("上传成功！", this.list);
          this.handleUpdate();
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log("上传已取消:", error.message);
          } else {
            this.$message.error("上传失败！");
          }
        });
    },
    handleUploadComplete() {},
    handleDeleteQuestionImage(index) {
      this.images.splice(index, 1);
      this.handleUpdate();
    },
    cancelClick() {
      this.$emit(
        "cancel",
        JSON.stringify({ index: this.index, data: this.dataObj }),
      );
    },
    saveClick() {
      const isEmpty = this.list.some((temp) => temp.url === "");
      if (isEmpty) {
        this.$message.error("请上传图片");
        return null;
      }
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.caseProblem = this.caseProblem;
      this.dataObj.chooseList = JSON.stringify({ list: this.list });
      this.$emit(
        "save",
        JSON.stringify({ index: this.index, data: this.dataObj }),
      );
    },
    handleUpdate() {
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.caseProblem = this.caseProblem;
      this.dataObj.chooseList = JSON.stringify({ list: this.list });
      this.$emit(
        "update",
        JSON.stringify({ index: this.index, data: this.dataObj }),
      );
    },
    showBigImage(url) {
      this.fangdaImgUrl = url;
      this.fangdaShow = true;
    },
    fangdaClose() {
      this.fangdaShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.question-header {
  display: flex;
  margin-bottom: 10px;
}

.question-select {
  background: #eef1f5;
  padding: 2px 6px;
  border-radius: 3px;
  margin-left: 6px;
  font-size: 14px;
}
.textarea-box {
  background: #fff;
  border: 1px solid #dcdde0;
  border-radius: 4px;
  padding: 8px 10px;
  margin-bottom: 10px;
}
.case-problem-textarea {
  width: 100%;
  min-height: 60px;
  border: none;
  outline: none;
  resize: none;
}
.textarea-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
}

.question-images {
  margin-bottom: 10px;
}
.guanbi {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 20px;
  height: 20px;
  z-index: 10;
}
.image-options {
  margin-bottom: 15px;
}
.image-view {
  width: 100%;
  background: #f4f4f4;
  border-radius: 8px;
  position: relative;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
}
.img {
  width: 100%;
}
.del {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  z-index: 10;
}

.plus-icon {
  position: relative;
  width: 30px;
  height: 30px;
  margin-top: 60px;
  margin-bottom: 28px;

  &::before,
  &::after {
    content: "";
    position: absolute;
    background-color: #b2b7bf;
  }

  &::before {
    left: 50%;
    top: 0;
    width: 2px;
    height: 100%;
    transform: translateX(-50%);
  }

  &::after {
    top: 50%;
    left: 0;
    width: 100%;
    height: 2px;
    transform: translateY(-50%);
  }
}

.add-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-btn {
  border: 1px solid #00c755;
  padding: 8px 16px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  color: #00c755;
  width: fit-content;
}

.add-batch {
  color: #509dee;
}

.hidden-upload {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionEdit/QuestionEditImageOrVideo.vue